import { Clipboard, LinkSize } from '@dreryk/react-components';

import { patientPortalTranslationKeys } from '../../translations';

type WidgetInfoClipboardProps = {
   readonly value: string;
};

export const WidgetInfoClipboard = (props: WidgetInfoClipboardProps): JSX.Element => {
   return <Clipboard label={patientPortalTranslationKeys.widget.copyCode} value={props.value} size={LinkSize.NORMAL} />;
};
